/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/joinNow/joinForm.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/joinNow/joinForm', exports: {} }; const exports = module.exports;

import loadingBars from '@fd-assets/core-styles/assets/javascripts/src-zugz/loadingBars.js';

import errorNotification from '@grins/fd-modules/bonz/modules/errorNotification';
import utils from '@grins/fd-modules/bonz/modules/utils';

import bonzConsts from '@grins/fd-modules/bonz/shared/constants';

import constants from '@grins/fd-modules/Fandango/constants';

import inputValidator from '@grins/fd-modules/shared/inputValidator';

import {
  Fandango_adobeLaunch as Fandango_adobeLaunch_track,
  Fandango_xhr as xhr,
  fd_url_manager as links,
  focusableInput_form as focusableForm
} from '@grins/fd-modules/splits/onering-global';

const { track } = Fandango_adobeLaunch_track;

const Selectors = {
    FORM: '#join-now-form',
    SAVE_BTN: '#join-now-submit-btn',
    TERMS_CHECKBOX: '#terms-confirm',
}
const Msgs = {
    GENERIC_ERROR: 'Something went wrong on our end. Please try again later.',
    DUPE_EMAIL: 'Welcome back! That Fandango account already exists, you can <strong><a href="{{url}}" class="validation-tip__link">sign in</a></strong> to your account.',
    TERMS_REQUIRED: 'You must agree to the Terms & Conditions and Privacy Policy to continue.',
}
const Styles = {
    LOADING_FULL: 'btn--loading-wrap',
}
function setSaving(isSaving) {
    const saveBtn = document.querySelector(Selectors.SAVE_BTN);
    if (isSaving) {
        loadingBars.start(saveBtn, { className: Styles.LOADING_FULL });
    }
    else {
        loadingBars.stop(saveBtn);
    }
}
function onFail(xhr = {}) {
    setSaving(false);
    const { responseJSON, status } = xhr;
    if (status === constants.HTTPStatusCodes.CONFLICT) {
        return errorNotification.show(responseJSON?.msg);
    }
    trackError(Msgs.GENERIC_ERROR);
    errorNotification.show(Msgs.GENERIC_ERROR);
}

function onDone(response: { success: boolean }, email: string, password: string) {
  setSaving(false);

  if (!response || !response.success) {
    return trackError(Msgs.GENERIC_ERROR);
  }

  track(bonzConsts.OmnitureEvents.SIGNUP_COMPLETE);
  utils.addFavorite();
  utils.saveAuthenticationToApp(email, password, 'join');
  setTimeout(() => window.location.href = utils.getDestinationURI(), 250);
}

function trackError(msg) {
    track({
        event: bonzConsts.OmnitureEvents.SIGNUP_ERROR,
        errorMessage: msg
    });
}
function validateFields(fields) {
    const { ValidationTypes, validate } = inputValidator;
    const { email, firstName, password } = fields;
    const validationRules = [{
            input: email,
            isRequired: true,
            type: ValidationTypes.EMAIL
        }, {
            input: firstName,
            isRequired: true,
            type: ValidationTypes.NAMES
        }, {
            input: password,
            isRequired: true,
            type: ValidationTypes.PASSWORD
        }];
    return validate(validationRules);
}

async function onSubmit(this: any, e: Event) {
  e.preventDefault();
  errorNotification.hide();
  setSaving(true);
  const fields = this.elements;
  const { hasErrors, errors } = validateFields(fields);

  if (hasErrors) {
    setSaving(false);
    return focusableForm.toggleErrors(errors, true);
  }

  if (!fields.termsConfirm.checked) {
    setSaving(false);
    return errorNotification.show(Msgs.TERMS_REQUIRED);
  }

  const email: string = fields.email.value;
  const password: string = fields.password.value;

  const data = {
    email,
    firstName: fields.firstName.value,
    password,
    termsConfirmed: fields.termsConfirm.checked,
    marketingOptIn: fields.marketingEmails ? fields.marketingEmails.checked : false
  };

  xhr.ajax({ url: links.snapiBonzJoin(), method: 'POST', data })
    .done((response: { success: boolean }) => onDone(response, email, password))
    .fail(onFail);
}

function init() {
  const form = document.querySelector(Selectors.FORM);
  form?.addEventListener('submit', onSubmit);
  focusableForm.attach(form);
}

export default {
    init
};
